/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import handleEvalReportError from './evalErrors';
import { buildRubricsListPath } from './rubricsApiPaths';

/** GET /rubrics — rubric rows for the Rubrics list, narrowed by graphId when the tenant has one. */
export default class RubricsListService extends BaseService {
  constructor() {
    super(constants.GET_RUBRICS_LIST, 'RubricsListStatus');
  }

  async handleEvent(eventName, event) {
    const { graphId, tenantId } = event;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    const url = buildRubricsListPath({ graphId });
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(url, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(url, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('rubricsData').setListResponse(response?.data);
  }

  handleError(error) {
    Framework.getStoreRegistry().getStore('rubricsData').failListRequest();
    handleEvalReportError(error);
  }
}
